module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAACXBIWXMAAAsSAAALEgHS3X78AAAA80lEQVRoge3asQ2DMBRF0Q/KGFCzA4t4DRfegYZFqL0DO7j2II4cpYggxceA8mK9I7lD2FfIAhKalJLUpJ3nORdVMUIIqa3q8uQrBLCGSzFIqdEM7/3fBP0Mg9AxCB2D0DEIHYPQMQgdg9A9tutblkVijKeW7ZxTHbeuq4QQiucZx/E1Pu2Ccoxzrime5YBpmk7N473f/WTFPYSOQegYhI5B6HY31r7v5f2PRDHtjdlam7quK55n+5Qg34KMMWdaDskx2sckLe4hdAxCxyB0DELHIHQMQscgdPW/4F0hf+alOc0d7163BA3DcMdpVbiHoInIE1S4Yd3zvdp7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/Images/OldCampIcons/006.png
// module id = 1016
// module chunks = 0